import propTypes from 'prop-types'
import {Button, Flex, Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

const ConfirmationScreen = ({goToNotifyCustomers}) => {
  const {t} = useTranslation('connectExpenseAccount')

  return (
    <Flex justify="center">
      <Flex flexDirection="column" width="400px" gap={6} pt={10}>
        {/* Title section */}
        <Flex flexDirection="column" gap={6}>
          <Text
            color="black"
            fontWeight="regular"
            fontSize="2xl"
            lineHeight="90%"
          >
            {t('modal.confirmation.title')}
          </Text>
          <Text color="black" fontSize="14px" lineHeight="125%">
            {t('modal.confirmation.description')}
          </Text>
        </Flex>

        <Flex
          flexDirection="column"
          backgroundColor="mld.neutral.50"
          p={4}
          gap={2}
        >
          <Text fontSize="xs" textTransform="uppercase">
            {t('modal.confirmation.nextStep.title')}
          </Text>
          <Text fontSize="sm" fontWeight="medium">
            {t('modal.confirmation.nextStep.subtitle')}
          </Text>
          <Text fontSize="xs" lineHeight="125%">
            {t('modal.confirmation.nextStep.description')}
          </Text>
          <Button
            onClick={goToNotifyCustomers}
            width="220px"
            variant="secondary"
            mt={4}
            _hover={{}}
          >
            {t('buttons.notifyYourCustomers')}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

ConfirmationScreen.propTypes = {
  goToNotifyCustomers: propTypes.func.isRequired,
}

export default ConfirmationScreen
